var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "menu-item-row-container",
      class: _vm.getStyleClasses,
      on: { click: _vm.handleRowClick }
    },
    [
      _c("div", { staticClass: "item-detail-info" }, [
        _c(
          "div",
          { staticClass: "image-wrapper" },
          [_c("menu-item-image", { attrs: { item: _vm.item } })],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "info-wrapper" }, [
          _c("h1", [_vm._v(_vm._s(_vm.item.name))]),
          _vm._v(" "),
          _c("p", {
            class: _vm.truncateForMobile(),
            domProps: { innerHTML: _vm._s(_vm.item.description) }
          })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c2971818", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2971818","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/common/MenuItemRow.vue
// module id = null
// module chunks = 